import type { DeploymentManifestDiffResource, KubernetesResourceManifestDiffResource } from "@octopusdeploy/octopus-server-client";
export function flattenDiffsResourceHierarchy(resources: DeploymentManifestDiffResource[] | undefined): KubernetesResourceManifestDiffResource[] {
    return (resources || []).reduce((array, current) => {
        const stepDiffs = current.StepDiffs.reduce((stepArray, currentStep) => [...stepArray, ...currentStep.DiffResources], new Array<KubernetesResourceManifestDiffResource>());
        return [...array, ...stepDiffs];
    }, new Array<KubernetesResourceManifestDiffResource>());
}
